'use client';

import React, { useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import WorkSection from './WorkSection';
import BookingSection from './BookingSection';
import TestimonialsSection from './TestimonialsSection';

export default function HomeClient() {
  const bookingRef = useRef<HTMLDivElement>(null);

  const scrollToBooking = () => {
    bookingRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="relative">
      {/* Grain overlay for premium texture */}
      <div className="grain-overlay" aria-hidden="true" />

      <Header onBookClick={scrollToBooking} />

      <main>
        <HeroSection onBookClick={scrollToBooking} />
        <AboutSection />
        <WorkSection />
        <TestimonialsSection />
        <div ref={bookingRef}>
          <BookingSection />
        </div>
      </main>

      <Footer />
    </div>
  );
}